/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipo file server-side-generated (add-pratica-allegati, Fase 4.d.3)
 */
export enum TipoFileSistema {

    PDF_PRATICA_ORIGINALE = 'PDF_PRATICA_ORIGINALE',

    CONVENZIONE_FIRMATA = 'CONVENZIONE_FIRMATA',

    CONVENZIONE_CONTROFIRMATA = 'CONVENZIONE_CONTROFIRMATA',

    CONVENZIONE_DA_FIRMARE = 'CONVENZIONE_DA_FIRMARE'
}

